<div class="page-container box-container-users">

  <audit-breadcrumb *ngIf="breadcrumbs" [breadcrumbs$]="breadcrumbs" (handleClick)="navigateToPrincipal($event)"></audit-breadcrumb>

  <div class="d-flex fd-row justify-space-between section-title-user pb-md-24 mt-16">
    <div
      class="text-color-secondary-1 d-flex fd-row align-items-center letter-spacing-1 text-size-32 text-md-size-24 text-weight-600">
      <sit-icon class="col-sm d-flex d-md-none" [icon]="Icon.user_y" [sizeClass]="'icon-size-40'"
        alt="icono de usuario"></sit-icon>
      <sit-icon (click)="navigateToVisor()" class="d-md-flex d-none" [icon]="Icon.previous_page_y"
        alt="Icono boton atrás" [sizeClass]="'icon-size-32'"></sit-icon>
      <span class="ml-8">{{ model?.data?.name }}</span>
    </div>
  </div>
  <hr class="mb-1 line-separator d-md-none" />

  <div class="box-container-table overflow-auto">
    <grid-page class="d-md-flex" [properties]="gridPageProps" (gridAction)="handleDownloadGridAction($event)"></grid-page>
  </div>

</div>